import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Typography,
  Grid,
  Paper,
  Button,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import moment from "moment";

const DestinationDetailsPage = () => {
  const { id } = useParams();
  const [destination, setDestination] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDestination = async () => {
      try {
        const docRef = doc(db, "destinations", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setDestination({ id: docSnap.id, ...docSnap.data() });
        } else {
          setNotFound(true);
        }
      } catch (error) {
        console.error("Error fetching destination:", error);
        setNotFound(true);
      }
    };

    fetchDestination();
  }, [id]);

  if (notFound) {
    return (
      <Container>
        <Typography variant="h5" color="error" align="center" sx={{ mt: 4 }}>
          Destination not found.
        </Typography>
        <Button
          variant="contained"
          sx={{ display: "block", mx: "auto", mt: 2 }}
          onClick={() => navigate("/destinations")}
        >
          Back to Destinations
        </Button>
      </Container>
    );
  }

  if (!destination) {
    return (
      <Typography align="center" sx={{ mt: 4 }}>
        Loading...
      </Typography>
    );
  }

  return (
    <Container>
      <Button
        variant="contained"
        sx={{ mb: 2 }}
        onClick={() => navigate("/destinations")}
      >
        Back
      </Button>
      <Typography variant="h4" gutterBottom>
        {destination.name}
      </Typography>
      <Grid container spacing={3}>
        {/* Images */}
        {destination.images && destination.images.length > 0 && (
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {destination.images.map((img, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card>
                    <CardMedia
                      component="img"
                      height="200"
                      image={img}
                      alt={`Destination Image ${index + 1}`}
                    />
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
        )}

        {/* Details */}
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">Details</Typography>
            <Typography>Country: {destination.country}</Typography>
            <Typography>State: {destination.state}</Typography>
            <Typography>City: {destination.city}</Typography>
            <Typography>Best Season: {destination.bestSeason}</Typography>
            <Typography>Description: {destination.description}</Typography>
            <Typography>
              Experiences:{" "}
              {destination.experiences?.length
                ? destination.experiences.join(", ")
                : "No experiences listed"}
            </Typography>
            <Typography>
              Popular Attractions:{" "}
              {destination.popularAttractions?.length
                ? destination.popularAttractions.join(", ")
                : "No attractions listed"}
            </Typography>
            <Typography>Created By: {destination.createdBy}</Typography>
            <Typography>
              Date Created:{" "}
              {moment
                .unix(destination.dateCreated?.seconds)
                .format("MMMM D, YYYY")}
            </Typography>
            <Typography>
              Last Updated:{" "}
              {moment
                .unix(destination.dateUpdated?.seconds)
                .format("MMMM D, YYYY")}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DestinationDetailsPage;
